<template>
  <div class="base-card" @click="$emit('click')" :class="{ active }">
    <div class="base-card__header">
      <span>{{ title }}</span>
    </div>
    <div class="base-card__body" :style="containerStyle" />
    <img :src="image" alt="icon" @load="handleLoad" @error="handleError" class="image-content" />
  </div>
</template>

<script>
export default {
  name: 'BaseCard',

  props: {
    title: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    isPlace: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgLoaded: false,
      imgError: false
    }
  },
  computed: {
    containerStyle() {
      const defaultImage = require(`@/assets/images/base/${this.isPlace ? 'roblox-default.webp' : 'user-solid.svg'}`)
      const size = !this.isPlace ? 'auto 80%' : 'cover'
      const src = this.imgLoaded && !this.imgError ? this.image : defaultImage

      return {
        background: `url(${src}) no-repeat center / ${size}`
      }
    }
  },
  methods: {
    handleLoad() {
      this.imgLoaded = true
    },
    handleError() {
      this.imgError = true
    }
  }
}
</script>

<style lang="scss">
@import './base-card';
</style>
